var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-table"},[_c('div',{staticClass:"table-header"},[_c('span',{staticClass:"category label"},[_vm._v("Final companies - "+_vm._s(_vm.finalCompanies.length))])]),_c('div',{staticClass:"inner"},_vm._l((_vm.finalCompanies),function(value,i){return _c('div',{key:'cat-' + i},[_c('span',[_vm._v(_vm._s(_vm.getCompanyByVismaId(value.vismaId).name))]),_c('span',{staticClass:"action remove",on:{"click":function($event){return _vm.$store.dispatch('notifications/updateExclusion', {
            type: 'add',
            field: 'Companies',
            value: value.vismaId,
          })}}},[_vm._v(" Exclude ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }